import React, { useEffect, useState } from 'react';
import useReduxState from 'src/hooks/useReduxState';

const ContentFilter = () => {
    const [showFilterCount, setShowFilterCount] = useState({});
    const [selectedFilterList, setSelectedFilterList] = useReduxState([], 'selectedFilterList');
    const [filterFacets, setFilterFacets] = useReduxState([], 'setFilterFacets');
    const [filterData, setFilterData] = useState({});

    const setStatusOfFilter = (filterName, key) => {
        let list = [...selectedFilterList]
        let selectValue = key + '-' + filterName
        const found = list.some(el => el.filterName === selectValue);
        if (!found) {
            list.push({ filterName: selectValue })
        } else {
            list.splice(list.findIndex(v => v.filterName === selectValue), 1);
        }

        setSelectedFilterList(list)
    }

    const clearAllFilter = () => {
        setSelectedFilterList([])
    }

    const getStatusOfForFieldActivated = (filterName, key) => {
        if (Array.isArray(selectedFilterList) && selectedFilterList.length > 0) {
            const selectValue = `${key}-${filterName}`;
            return selectedFilterList.some(v => v.filterName === selectValue);
        }
        return false;
    };

    const organizeData = (data) => {
        return data.reduce((acc, item) => {
            const [category, subcategory] = item.name.split('-');
            const formattedCategory = category.trim();
            const formattedName = subcategory.trim().replace(/\b\w/g, char => char);

            if (!acc[formattedCategory]) {
                acc[formattedCategory] = {};
            }

            if (!acc[formattedCategory][formattedName]) {
                acc[formattedCategory][formattedName] = { Count: 0, Name: formattedName };
            }

            acc[formattedCategory][formattedName].Count += item.count;
            return acc;
        }, {});
    };

    useEffect(() => {
        if (filterFacets.length > 0) {
            const result = organizeData(filterFacets);
            setFilterData({ ...filterData, ...result });
        }
    }, [filterFacets]);

    const toggleFilterCount = (category, totalItems) => {
        setShowFilterCount(prevState => ({...prevState,[category]: totalItems}));
    };

    return (
        <div className="mt-0 mt-md-5 m-b-20 newcontent-filter">
            <div className="bs5 d-flex justify-content-between">
                <span className="text-black font-bold mb-1 font-14">NARROW YOUR RESULTS</span>
                {selectedFilterList.length > 0 && (
                    <a className="cursor-pointer" onClick={clearAllFilter}>
                        Clear All
                    </a>
                )}
            </div>

            {filterData && Object.entries(filterData).length > 0 && (
                <div className="panel-group" id="accordion">
                    {Object.entries(filterData).map(([category, items], i) => {
                        const totalItems = Object.entries(items).length;
                        const currentShowCount = showFilterCount[category] || 10; 

                        return (
                            <div className="panel panel-default" key={category}>
                                <div className="panel-heading">
                                    <h4 className="panel-title">
                                        <a data-toggle="collapse" href={`#collapse${i}`}>
                                            {category}
                                        </a>
                                    </h4>
                                </div>
                                <div id={`collapse${i}`} className="panel-collapse collapse in">
                                    <div className="panel-body">
                                        {Object.entries(items).map(([key, item], j) => {
                                            return (
                                                j < currentShowCount && (
                                                    <div className="form-check" key={item.Name}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={item.Name}
                                                            name={item.Name}
                                                            checked={getStatusOfForFieldActivated(item.Name, category)}
                                                            onChange={() => setStatusOfFilter(item.Name, category)}
                                                        />
                                                        <label className="form-check-label" htmlFor={item.Name}>
                                                            {item.Name}
                                                            <span className="filter-count"> ({item.Count})</span>
                                                        </label>
                                                    </div>
                                                )
                                            );
                                        })}

                                        {totalItems > 10 && (
                                            <>
                                                {currentShowCount === 10 && (
                                                    <div className="mt-2">
                                                        <a
                                                            href={void 0}
                                                            onClick={() => toggleFilterCount(category, totalItems)}
                                                            className="text-blue2 font-bold box-style"
                                                        >
                                                            See More
                                                        </a>
                                                    </div>
                                                )}
                                                {currentShowCount > 10 && (
                                                    <div className="mt-2">
                                                        <a
                                                            href={void 0}
                                                            onClick={() => toggleFilterCount(category, 10)}
                                                            className="text-blue2 font-bold box-style"
                                                        >
                                                            See Less
                                                        </a>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default ContentFilter;
